import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { faEllipsisVertical as faEllipsisVerticalLight } from "@fortawesome/pro-light-svg-icons/faEllipsisVertical";
import { faAlarmClock } from "@fortawesome/pro-regular-svg-icons/faAlarmClock";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { faArrowRightFromBracket } from "@fortawesome/pro-regular-svg-icons/faArrowRightFromBracket";
import { faArrowsLeftRight } from "@fortawesome/pro-regular-svg-icons/faArrowsLeftRight";
import { faBookOpenCover } from "@fortawesome/pro-regular-svg-icons/faBookOpenCover";
import { faBookOpenReader } from "@fortawesome/pro-regular-svg-icons/faBookOpenReader";
import { faCalendar } from "@fortawesome/pro-regular-svg-icons/faCalendar";
import { faCalendarCirclePlus } from "@fortawesome/pro-regular-svg-icons/faCalendarCirclePlus";
import { faCalendarDay } from "@fortawesome/pro-regular-svg-icons/faCalendarDay";
import { faCalendars as faCalendarsRegular } from "@fortawesome/pro-regular-svg-icons/faCalendars";
import { faCalendarXmark } from "@fortawesome/pro-regular-svg-icons/faCalendarXmark";
import { faCamera as faCameraRegular } from "@fortawesome/pro-regular-svg-icons/faCamera";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faChevronUp } from "@fortawesome/pro-regular-svg-icons/faChevronUp";
import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { faDash } from "@fortawesome/pro-regular-svg-icons/faDash";
import { faDownload } from "@fortawesome/pro-regular-svg-icons/faDownload";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons/faEllipsis";
import { faEnvelope } from "@fortawesome/pro-regular-svg-icons/faEnvelope";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faExternalLink } from "@fortawesome/pro-regular-svg-icons/faExternalLink";
import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import { faFaceViewfinder } from "@fortawesome/pro-regular-svg-icons/faFaceViewfinder";
import { faFile } from "@fortawesome/pro-regular-svg-icons/faFile";
import { faFileArrowUp } from "@fortawesome/pro-regular-svg-icons/faFileArrowUp";
import { faFingerprint } from "@fortawesome/pro-regular-svg-icons/faFingerprint";
import { faForward as faForwardRegular } from "@fortawesome/pro-regular-svg-icons/faForward";
import { faGear } from "@fortawesome/pro-regular-svg-icons/faGear";
import { faGlobe } from "@fortawesome/pro-regular-svg-icons/faGlobe";
import { faHeart } from "@fortawesome/pro-regular-svg-icons/faHeart";
import { faHome } from "@fortawesome/pro-regular-svg-icons/faHome";
import { faImages as faImagesRegular } from "@fortawesome/pro-regular-svg-icons/faImages";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons/faLocationDot";
import { faMagnifyingGlassPlus } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlassPlus";
import { faMessage } from "@fortawesome/pro-regular-svg-icons/faMessage";
import { faMessageCheck } from "@fortawesome/pro-regular-svg-icons/faMessageCheck";
import { faMessageExclamation } from "@fortawesome/pro-regular-svg-icons/faMessageExclamation";
import { faMessages } from "@fortawesome/pro-regular-svg-icons/faMessages";
import { faMobile } from "@fortawesome/pro-regular-svg-icons/faMobile";
import { faOctagonXmark } from "@fortawesome/pro-regular-svg-icons/faOctagonXmark";
import { faPaperclip } from "@fortawesome/pro-regular-svg-icons/faPaperclip";
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faPause } from "@fortawesome/pro-regular-svg-icons/faPause";
import { faPen } from "@fortawesome/pro-regular-svg-icons/faPen";
import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import { faPhone } from "@fortawesome/pro-regular-svg-icons/faPhone";
import { faPlay } from "@fortawesome/pro-regular-svg-icons/faPlay";
import { faPlus as faPlusRegular } from "@fortawesome/pro-regular-svg-icons/faPlus";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import { faRedo } from "@fortawesome/pro-regular-svg-icons/faRedo";
import { faRefresh } from "@fortawesome/pro-regular-svg-icons/faRefresh";
import { faSalad } from "@fortawesome/pro-regular-svg-icons/faSalad";
import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch";
import { faShareFromSquare } from "@fortawesome/pro-regular-svg-icons/faShareFromSquare";
import { faShield } from "@fortawesome/pro-regular-svg-icons/faShield";
import { faSquare } from "@fortawesome/pro-regular-svg-icons/faSquare";
import { faThumbsUp } from "@fortawesome/pro-regular-svg-icons/faThumbsUp";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
import { faTrash } from "@fortawesome/pro-regular-svg-icons/faTrash";
import { faUser } from "@fortawesome/pro-regular-svg-icons/faUser";
import { faUserCircle } from "@fortawesome/pro-regular-svg-icons/faUserCircle";
import { faUserGroupSimple } from "@fortawesome/pro-regular-svg-icons/faUserGroupSimple";
import { faUserPlus } from "@fortawesome/pro-regular-svg-icons/faUserPlus";
import { faUserSlash } from "@fortawesome/pro-regular-svg-icons/faUserSlash";
import { faVideo } from "@fortawesome/pro-regular-svg-icons/faVideo";
import { faArrowDown as faArrowDownSolid } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { faArrowUp as faArrowUpSolid } from "@fortawesome/pro-solid-svg-icons/faArrowUp";
import { faCheckSquare as faCheckSquareSolid } from "@fortawesome/pro-solid-svg-icons/faCheckSquare";
import { faHeadset as faHeadsetSolid } from "@fortawesome/pro-solid-svg-icons/faHeadset";
import { faUserDoctor as faUserDoctorSolid } from "@fortawesome/pro-solid-svg-icons/faUserDoctor";
import { faUserGroup as faUserGroupSolid } from "@fortawesome/pro-solid-svg-icons/faUserGroup";

enum FAIconName {
  AlarmClock = "faAlarmClock",
  ArrowDownSolid = "faArrowDownSolid",
  ArrowLeft = "faArrowLeft",
  ArrowRight = "faArrowRight",
  ArrowRightFromBracket = "faArrowRightFromBracket",
  ArrowsLeftRight = "faArrowsLeftRight",
  ArrowUpSolid = "faArrowUpSolid",
  BookOpenReader = "faBookOpenReader",
  Calendar = "faCalendar",
  CalendarCirclePlus = "faCalendarCirclePlus",
  CalendarDay = "faCalendarDay",
  Calendars = "faCalendarsRegular",
  CalendarXmark = "faCalendarXmark",
  Camera = "faCameraRegular",
  Check = "faCheck",
  CheckSquare = "faCheckSquareSolid",
  ChevronDown = "faChevronDown",
  ChevronLeft = "faChevronLeft",
  ChevronRight = "faChevronRight",
  ChevronUp = "faChevronUp",
  Clock = "faClock",
  Dash = "faDash",
  Download = "faDownload",
  Ellipsis = "faEllipsis",
  EllipsisVerticalLight = "faEllipsisVerticalLight",
  Envelope = "faEnvelope",
  ExclamationCircle = "faExclamationCircle",
  ExclamationTriangle = "faExclamationTriangle",
  ExternalLink = "faExternalLink",
  Eye = "faEye",
  EyeSlash = "faEyeSlash",
  FaceWayfinder = "faFaceViewfinder",
  File = "faFile",
  FileArrowUp = "faFileArrowUp",
  Fingerprint = "faFingerprint",
  Fingertip = "faFingertip",
  Forward = "faForwardRegular",
  Gear = "faGearRegular",
  Globe = "faGlobe",
  HeadsetSolid = "faHeadsetSolid",
  Heart = "faHeart",
  Home = "faHome",
  Images = "faImagesRegular",
  InfoCircle = "faInfoCircle",
  LocationDot = "faLocationDot",
  MagnifyingGlassPlus = "faMagnifyingGlassPlus",
  Message = "faMessage",
  MessageCheck = "faMessageCheck",
  MessageExclamation = "faMessageExclamation",
  Messages = "faMessages",
  Mobile = "faMobile",
  OctagonXmark = "faOctagonXmark",
  OpenBook = "faBookOpenCover",
  Paperclip = "faPaperclip",
  PaperPlane = "faPaperPlane",
  Pause = "faPause",
  Pen = "faPen",
  PenToSquare = "faPenToSquare",
  Phone = "faPhone",
  Play = "faPlay",
  Plus = "faPlusRegular",
  PlusCircle = "faPlusCircle",
  Redo = "faRedo",
  Refresh = "faRefresh",
  Salad = "faSalad",
  Search = "faSearch",
  ShareFromSquare = "faShareFromSquare",
  Shield = "faShield",
  Square = "faSquare",
  ThumbsUp = "faThumbsUp",
  Times = "faTimes",
  Trash = "faTrash",
  User = "faUser",
  UserCircle = "faUserCircle",
  UserDoctor = "faUserDoctorSolid",
  UserGroupSimple = "faUserGroupSimple",
  UserGroupSolid = "faUserGroupSolid",
  UserPlus = "faUserPlus",
  UserSlash = "faUserSlash",
  Video = "faVideo",
}

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const IconDefinitions: Record<FAIconName, IconDefinition> = {
  [FAIconName.AlarmClock]: faAlarmClock,
  [FAIconName.ArrowDownSolid]: faArrowDownSolid,
  [FAIconName.ArrowLeft]: faArrowLeft,
  [FAIconName.ArrowRight]: faArrowRight,
  [FAIconName.ArrowRightFromBracket]: faArrowRightFromBracket,
  [FAIconName.ArrowsLeftRight]: faArrowsLeftRight,
  [FAIconName.ArrowUpSolid]: faArrowUpSolid,
  [FAIconName.BookOpenReader]: faBookOpenReader,
  [FAIconName.Calendar]: faCalendar,
  [FAIconName.CalendarCirclePlus]: faCalendarCirclePlus,
  [FAIconName.CalendarDay]: faCalendarDay,
  [FAIconName.Calendars]: faCalendarsRegular,
  [FAIconName.CalendarXmark]: faCalendarXmark,
  [FAIconName.Camera]: faCameraRegular,
  [FAIconName.Check]: faCheck,
  [FAIconName.CheckSquare]: faCheckSquareSolid,
  [FAIconName.ChevronDown]: faChevronDown,
  [FAIconName.ChevronLeft]: faChevronLeft,
  [FAIconName.ChevronRight]: faChevronRight,
  [FAIconName.ChevronUp]: faChevronUp,
  [FAIconName.Clock]: faClock,
  [FAIconName.Dash]: faDash,
  [FAIconName.Download]: faDownload,
  [FAIconName.Ellipsis]: faEllipsis,
  [FAIconName.EllipsisVerticalLight]: faEllipsisVerticalLight,
  [FAIconName.Envelope]: faEnvelope,
  [FAIconName.ExclamationCircle]: faExclamationCircle,
  [FAIconName.ExclamationTriangle]: faExclamationTriangle,
  [FAIconName.ExternalLink]: faExternalLink,
  [FAIconName.Eye]: faEye,
  [FAIconName.EyeSlash]: faEyeSlash,
  [FAIconName.FaceWayfinder]: faFaceViewfinder,
  [FAIconName.File]: faFile,
  [FAIconName.FileArrowUp]: faFileArrowUp,
  [FAIconName.Fingerprint]: faFingerprint,
  [FAIconName.Fingertip]: faFingerprint,
  [FAIconName.Forward]: faForwardRegular,
  [FAIconName.Gear]: faGear,
  [FAIconName.Globe]: faGlobe,
  [FAIconName.HeadsetSolid]: faHeadsetSolid,
  [FAIconName.Heart]: faHeart,
  [FAIconName.Home]: faHome,
  [FAIconName.Images]: faImagesRegular,
  [FAIconName.InfoCircle]: faInfoCircle,
  [FAIconName.LocationDot]: faLocationDot,
  [FAIconName.MagnifyingGlassPlus]: faMagnifyingGlassPlus,
  [FAIconName.Message]: faMessage,
  [FAIconName.MessageCheck]: faMessageCheck,
  [FAIconName.MessageExclamation]: faMessageExclamation,
  [FAIconName.Messages]: faMessages,
  [FAIconName.Mobile]: faMobile,
  [FAIconName.OctagonXmark]: faOctagonXmark,
  [FAIconName.OpenBook]: faBookOpenCover,
  [FAIconName.Paperclip]: faPaperclip,
  [FAIconName.PaperPlane]: faPaperPlane,
  [FAIconName.Pause]: faPause,
  [FAIconName.Pen]: faPen,
  [FAIconName.PenToSquare]: faPenToSquare,
  [FAIconName.Phone]: faPhone,
  [FAIconName.Play]: faPlay,
  [FAIconName.Plus]: faPlusRegular,
  [FAIconName.PlusCircle]: faPlusCircle,
  [FAIconName.Redo]: faRedo,
  [FAIconName.Refresh]: faRefresh,
  [FAIconName.Salad]: faSalad,
  [FAIconName.Search]: faSearch,
  [FAIconName.ShareFromSquare]: faShareFromSquare,
  [FAIconName.Shield]: faShield,
  [FAIconName.Square]: faSquare,
  [FAIconName.ThumbsUp]: faThumbsUp,
  [FAIconName.Times]: faTimes,
  [FAIconName.Trash]: faTrash,
  [FAIconName.User]: faUser,
  [FAIconName.UserCircle]: faUserCircle,
  [FAIconName.UserDoctor]: faUserDoctorSolid,
  [FAIconName.UserGroupSimple]: faUserGroupSimple,
  [FAIconName.UserGroupSolid]: faUserGroupSolid,
  [FAIconName.UserPlus]: faUserPlus,
  [FAIconName.UserSlash]: faUserSlash,
  [FAIconName.Video]: faVideo,
};

export { FAIconName, IconDefinitions };
